import { Entity, Field } from "typegraph";

@Entity({ one: "category", many: "categories" })
export default class Category {

	@Field()
	public id: number;

	@Field()
	public name: string;
}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/Category.ts